import Vue from 'vue';

//helper app
import './Components/Helpers/HelperComponent';

// Sports
Vue.component('sports-table-with-filter', require('./Components/Views/Custom/Tables/PinnacleSports').default);
Vue.component('history-sports-table', require('./Components/Views/Custom/Tables/PinnacleSportsHistory').default);

Vue.component('betfair-sports-table-with-filter', require('./Components/Views/Custom/Tables/BetfairSports').default);
Vue.component('betfair-log-table-with-filter', require('./Components/Views/Custom/Tables/BetfairLog').default);

Vue.component('betfair-view-game', require('./Components/Views/Games/Betfair/View').default);
Vue.component('betfair-odds-datatable', require('./Components/Views/Games/Betfair/OddsDatatable').default);

// Combos
Vue.component('combos-open', require('./Components/Views/Combos/OpenCombos').default);
Vue.component('combos-generated', require('./Components/Views/Combos/GeneratedCombos').default);

Vue.component('pinnacle-view-game', require('./Components/Views/Games/Pinnacle/View').default);
Vue.component('pinnacle-view-team', require('./Components/Views/Teams/Pinnacle/View').default);
Vue.component('pinnacle-view-league', require('./Components/Views/Leagues/Pinnacle/View').default);
Vue.component('pinnacle-odds-datatable', require('./Components/Views/Games/Pinnacle/OddsDatatable').default);
Vue.component('pinnacle-teams-datatable', require('./Components/Views/Teams/Pinnacle/TeamsDatatable').default);
Vue.component('pinnacle-leagues-datatable', require('./Components/Views/Leagues/Pinnacle/LeaguesDatatable').default);

/**
 * all component of GUD
 */
Vue.component('personal-information', require('./Components/Views/Auth/PersonalInformation').default);
Vue.component('password-change', require('./Components/Views/Auth/PasswordChange').default);
Vue.component('social-links', require('./Components/Views/Auth/SocialLinks').default);
Vue.component('login', require('./Components/Views/Auth/Login').default);
Vue.component('password-reset', require('./Components/Views/Auth/PasswordReset').default);
Vue.component('reset-password', require('./Components/Views/Auth/ResetPassword').default);
Vue.component('registration', require('./Components/Views/Auth/Registration').default);
Vue.component('my-profile', require('./Components/Views/Auth/Profile').default);

// Settings
Vue.component('app-setting', require('./Components/Views/Settings/Index').default);
Vue.component('general-setting', require('./Components/Views/Settings/GeneralSetting').default);
Vue.component('email-setting', require('./Components/Views/Settings/EmailSetting').default);
Vue.component('sms-setting', require('./Components/Views/Settings/SmsSetting').default);
Vue.component('google-re-captcha-setting', require('./Components/Views/Settings/GoogleRecaptchaSetting').default);
Vue.component('notification-settings', require('./Components/Views/Settings/Notification/Settings/Index').default);
Vue.component('database-template', require('./Components/Views/Settings/Notification/Template/DatabaseTemplate').default);
Vue.component('mail-template', require('./Components/Views/Settings/Notification/Template/MailTemplate').default);
Vue.component('payment-method', require('./Components/Views/Settings/PaymentMethod/PaymentMethod').default);
Vue.component('payment-method-create-edit-modal', require('./Components/Views/Settings/PaymentMethod/PaymentMethodCreateEditModal').default);

// User and Roles
Vue.component('user-roles', require('./Components/Views/UserRoles/Index').default);
Vue.component('group-of-users', require('./Components/Views/UserRoles/Roles/GroupOfUsers').default);

// Layouts
Vue.component('app-top-bar', require('./Components/Views/Layouts/Nabar').default);
Vue.component('app-sidebar', require('./Components/Views/Layouts/Sidebar').default);

// notifications
Vue.component('all-notification', require('./Components/Views/Custom/Notifications/AllNotifications').default);
Vue.component('notifications-view', require('./Components/Views/Custom/Notifications/NotificationsView').default);
Vue.component('notifications-add-edit-modal', require('./Components/Views/Custom/Notifications/NotificationsAddEditModal').default);

Vue.component('re-captcha', require('./Components/Views/Auth/ReCaptcha').default);
Vue.component('payment-view', require('./Components/Views/Demo/Pages/PaymentMethodView').default);